/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTia3plSurveyDetail.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/tia-3pl-survey-detail";

export class AutogenModelTia3plSurveyDetail<RowType extends ModelRow> extends Endpoint<RowType, RowTia3plSurveyDetailFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTia3plSurveyDetail extends ModelRow<RowTia3plSurveyDetailFields> {
	constructor(values?: Partial<RowTia3plSurveyDetailFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTia3plSurveyDetailFields {
	code_name: string;
	company_id: string;
	data_code: string;
	description: string;
	id: string;
	is_active: string;
	sql_query: string;
}

